import React from "react";
import { formatDate } from "../../../service/convert/date";
import { useNavigate } from "react-router-dom";
import { IBlog } from "../../../store/@types/blogs";
import { FaHeart, FaMessage } from "react-icons/fa6";
import { FaChevronRight } from "react-icons/fa";
import PreloadImage from "../../../components/ui/ImagePreloader/ImagePreloader";
import imageplaceholder from "../../../assets/images/imgplaceholders/placeholder.png";

type IBlogCard = {
  item: IBlog;
};

const BlogCard: React.FC<IBlogCard> = ({ item }) => {
  const navigate = useNavigate();

  return (
    <div
      onClick={() => navigate(`/blog/${item?.id}`)}
      className="w-full  mx-auto overflow-hidden rounded-2xl shadow-md cursor-pointer bg-white transition-all duration-300 hover:shadow-xl hover:translate-y-[-5px]"
    >
      <div className="h-48 overflow-hidden">
        <PreloadImage
          loading="lazy"
          imgSrc={item?.image}
          imgAlt={item?.title}
          imgClassName="object-cover object-center w-full h-64 transition-transform duration-300"
          placeholderSrc={imageplaceholder}
        />
      </div>

      <div className="p-6">
        <div className="flex items-center justify-between mb-3">
          <span className="bg-primary-500 py-1 px-3 rounded-full text-[0.7rem] font-semibold tracking-widest text-primary-950">
            {item.category.name}
          </span>
          <div className="text-primary-900">{formatDate(item.created_at)}</div>
        </div>
        <h3 className="text-xl font-bold text-primary-900 mb-4 line-clamp-2 capitalize">
          {item.title}
        </h3>

        <div className="mt-4 pt-4 border-t border-primary-200 flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <div className="flex items-center text-primary-600">
              <FaHeart className="h-4 w-4 mr-1 fill-current" />
              <span>{item.likes_count}</span>
            </div>
            <div className="flex items-center text-primary-600 ">
              <FaMessage className="h-4 w-4 mr-1" />
              <span>{item.comments_count}</span>
            </div>
          </div>
          <a
            href={`/blog/${item.id}`}
            className="text-primary-600 hover:text-primary-700 font-medium flex items-center "
          >
            Read More <FaChevronRight className="h-4 w-4 ml-1" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default BlogCard;
